import { DataFieldProps } from "../../types";
import { defineBaseFieldComponent } from "./baseField";
import * as Classes from "./classes";

export const DataField = defineBaseFieldComponent<DataFieldProps, ReturnType<typeof formatField>>(
    {
        name: "dataField",
        additionalRowAttributes: () => ({ class: ["treebrowserow", "jsDraggable", "fieldspan"] }),
        nameCell: (field) => <td>
            <span class=
                {{
                    [Classes.column_content]: true,
                    [Classes.treeBrowse]: true,
                    [Classes.treeBrowseSectionHeader]: true,
                    [Classes.selectable]: true,
                    [Classes.nowrap]: true,
                    [Classes.field]: true,
                }}>
                {field.displayName}
            </span>
            {field.isCalculated || field.isOperation ? "*" : null}
        </td>,
        parametersCell: (field) =>
            <td>
                <input type="checkbox" disabled={true} checked={field.parameters?.length > 0} />
            </td>,
        typeIcon: (field: DataFieldProps) => field.svgClass,
        fieldKey: (field: DataFieldProps) => field.fieldPath,
        formatField: formatField,
    });

function formatField(field: DataFieldProps)
{
    const result =
    {
        // These correspond to old data- attribute names, used in reporting and elsewhere
        fieldType: field.format,
        fieldName: field.fieldPath, // TODO we should differentiate FieldName and FieldPath
        fieldModule: field.moduleName,
        fieldObject: field.objectName
    };
    return result;
}
